module.exports = __webpack_public_path__ + "img/hero-bg.b96e67fa.png";